var DEFAULT_BRAND = 'nimrod';
var DEFAULT_MAX_ANCESTORS = 2;
var DEFAULT_MAX_LENGTH = 60;
var PATH_SEPARATOR = ' / ';

function recordLabel(record) {
  if (!record) return '';
  if (record.name === 'root') return '';

  var label = record.name || record['@class'] || '';
  if (record.roomNumber) {
    label = (label + ' ' + record.roomNumber).trim();
  }
  return label;
}

function recordsMatch(left, right) {
  if (!left || !right) return false;
  if (left['@rid'] && right['@rid']) {
    return String(left['@rid']) === String(right['@rid']);
  }
  return left === right;
}

function recordPath(record, options) {
  if (Array.isArray(options && options.path) && options.path.length) {
    return options.path;
  }
  if (Array.isArray(record && record.path) && record.path.length) {
    return record.path;
  }
  if (Array.isArray(record && record.breadcrumbs) && record.breadcrumbs.length) {
    return record.breadcrumbs;
  }

  var resource = (options && options.resource) || (record && record.resource);
  var resourcePath = Array.isArray(resource && resource.path) && resource.path.length
    ? resource.path
    : (Array.isArray(resource && resource.breadcrumbs) ? resource.breadcrumbs : []);
  return resourcePath.length ? resourcePath.concat([record]) : [];
}

function nearestAncestors(record, options) {
  var path = recordPath(record, options);
  var recordIndex = path.findIndex(function (pathRecord) {
    return recordsMatch(pathRecord, record);
  });

  if (recordIndex === 0) {
    return path.slice(1);
  }
  if (recordIndex > 0) {
    return path.slice(0, recordIndex).reverse();
  }

  return path.slice().reverse();
}

function build(record, options) {
  var settings = options || {};
  var brand = settings.brand || DEFAULT_BRAND;
  var maxAncestors = Number.isInteger(settings.maxAncestors)
    ? Math.max(0, settings.maxAncestors)
    : DEFAULT_MAX_ANCESTORS;
  var maxLength = Number.isInteger(settings.maxLength)
    ? settings.maxLength
    : DEFAULT_MAX_LENGTH;
  var currentLabel = recordLabel(record) || settings.fallback || '';
  var prefix = brand + ' | ';

  if (!currentLabel) return prefix;

  var selectedAncestors = [];
  nearestAncestors(record, settings).slice(0, maxAncestors).some(function (ancestor) {
    var ancestorLabel = recordLabel(ancestor);
    if (!ancestorLabel) return false;

    var candidateAncestors = [ancestorLabel].concat(selectedAncestors);
    var candidate = prefix + candidateAncestors.concat(currentLabel).join(PATH_SEPARATOR);
    if (candidate.length > maxLength) return true;

    selectedAncestors = candidateAncestors;
    return false;
  });

  return prefix + selectedAncestors.concat(currentLabel).join(PATH_SEPARATOR);
}

function set(record, options) {
  var title = build(record, options);
  if (typeof document !== 'undefined') {
    document.title = title;
  }
  return title;
}

module.exports = {
  build: build,
  set: set,
  recordLabel: recordLabel,
  DEFAULT_MAX_LENGTH: DEFAULT_MAX_LENGTH
};
